/**
 * Angular imports.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { FunCollectionService } from '../common-functions/fun-collection.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { AuthService } from '../../auth/auth.service';
import { Analytics } from 'analytics2.0';
/**
 * Constant import.
 */
import {
  NAVIGATION_TARGET,
  EXPLORE_IDENTIFIER,
  TOOLTIP_POSITION,
  EXPLORE_SECTION,
  PRODUCT_TYPE_CONSTANT,
  SCREEN_NAME,
  ACTION_ON,
  CTA_TYPE,
  ACTION_TYPE,
  PRODUCT_TYPE_CONSTANT_NAME
} from './../../constants/app.constants';

import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';

/**
 * Constant import.
 */
// import { NEW_TAG } from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../analytics-event/analytics.model';

/**
 * Rxjs import.
 */
import { Subscription } from 'rxjs';
import { CLICK, ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
* Mobile Explore Component
*/
@Component({
  selector: 'app-mobile-explore',
  templateUrl: './mobile-explore.component.html',
  styleUrls: ['./mobile-explore.component.scss']
})
export class MobileExploreComponent implements OnInit, OnDestroy {

  public tooltip_data = [];
  public loginUserCustomeId: string;
  /**
   * used to hold explore section data.
   */
  public exploreSection = EXPLORE_SECTION;
  /**
   * Session time object.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Analyticsdata object.
   */
  public analyticsData: AnalyticsInterface;

  /**
   * Route navigation target from constant.
   */
  public navigationTarget = NAVIGATION_TARGET;
  /**
   * Explore identifier from constant.
   */
  public exploreIdentifiers = EXPLORE_IDENTIFIER;
  /**
   * Tooltip position from constant.
   */
  public position = TOOLTIP_POSITION;
  
  /**
   * entry time stamp
   */
  exploreEntryTimeStamp: number;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    public fcs: FunCollectionService,
    public masterSer: MasterserviceService,
    private router: Router,
    public dss: DataStorageService,
    private authService: AuthService,
    private analyticsEventService: AnalyticsEventService,
    private analyticSdk: Analytics
  ) {
  }

  /**
   * Mobile Explore Component
   */
  ngOnInit(): void {
    this.tooltip_data = this.dss.tooltip_list.filter(obj => obj.screen_identifier == 'EXPLORE_LIST');
    this.exploreEntryTimeStamp =  new Date().getTime();
    const entryData: ENTRY= {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
      entity_code: 0,
      source: this.fcs.currentScreename ? this.fcs.currentScreename : localStorage.getItem('triggerSource'),
      current_screen_name: SCREEN_NAME.EXPLORE_LIST,
      start_time: this.exploreEntryTimeStamp,
    }
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.fcs.currentScreename = SCREEN_NAME.EXPLORE_LIST;
    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
  }

  /**
   * Mobile Explore Component
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigateFromExplore(exp: any): void {
    this.dss.setCalDayMonthYr();
    const date = new Date();
    this.sessiontime.start_time = date.getTime().toString();
    if (exp.value) {
      this.logClickEvent(PRODUCT_TYPE_CONSTANT_NAME.OTHER,exp.value, CTA_TYPE.OPTION);
    }
    switch (exp.value) {

      /**********************group sort order 1*****************/
      case 'pharma': {
        this.masterSer.url_after_leave_cme = '/channel/list';
        this.router.navigateByUrl('/pharma/list');
        break;
      }
      case 'news': {
        // this.hideExpore();
        this.masterSer.url_after_leave_cme = '/news/list';
        this.router.navigateByUrl('/news/list');
        break;
      }
      case 'drugsample': {
        this.masterSer.url_after_leave_cme = '/drugsample/list/drugs';
        this.router.navigateByUrl('/drugsample/list/drugs');
        break;
      }
      case 'cme': {
        this.masterSer.url_after_leave_cme = '/cme';
        this.router.navigateByUrl('/cme');
        break;
      }
      case 'channel': {
        this.masterSer.url_after_leave_cme = '/channel/list';
        this.router.navigateByUrl('/channel/list');
        break;
      }
      case 'productchannel': {
        this.fcs.navigateToChannelDetail(exp.product_id);
        break;
      }
      case 'event': {
        this.masterSer.url_after_leave_cme = '/event/list/upcoming';
        this.fcs.navigateToEventDetail(0);
        break;
      }
      case 'online_event': {
        this.masterSer.url_after_leave_cme = '/event/list/upcoming';
        this.fcs.navigateToNewEventDetail(0);
        break;
      }
      case 'journal': {
        this.masterSer.url_after_leave_cme = '/clinical';
        this.router.navigateByUrl('/clinical/list');
        break;
      }
      /**********************group sort order 2*****************/
      case 'clinicalcases': {
        const filter = [{ 'key': 'properties', 'value': ['cases'] }];
        this.dss.gr_filter = filter;
        this.router.navigateByUrl('/web/list');

        break;
      }
      case 'insights': {
        const filter = [{ filter_type: 'kind', filter_id: ['post'] }];
        this.dss.gr_filter = filter;
        this.router.navigateByUrl('/web/list');

        break;
      }
      case 'poll': {
        const filter = [{ 'key': 'properties', 'value': ['poll'] }];
        this.dss.gr_filter = filter;
        this.router.navigateByUrl('/web/list');

        break;
      }
      case 'chats': {
        if (this.dss.user_profile_data.profile.permission != 'all') {
          this.fcs.assignAssociation('open_chat');
        } else {
          this.fcs.navigateToChat();
        }
        break;
      }
      /**********************group sort order 3*****************/
      case 'mydownload': {
        break;
      }
      case 'mybookmarks': {
        this.masterSer.url_after_leave_cme = '/webprofile/bookmark/case';
        this.router.navigateByUrl('/webprofile/bookmark/case');
        break;
      }
      case 'qna': {
        this.masterSer.url_after_leave_cme = '/web/profile/' + this.loginUserCustomeId + '/qa';

        this.fcs.navigateToUserProfie_spe_sec(this.loginUserCustomeId, 'qa');
        break;
      }
      case 'settings': {
        break;
      }
      case 'rewards': {
        this.masterSer.url_after_leave_cme = 'refer-and-earn/referral';
        this.fcs.navigateToReferal();
        break;
      }

      case 'doctalk': {
        this.masterSer.url_after_leave_cme = 'doctalk/list';
        this.fcs.navigateToDoctalk();
        break;
      }
      case 'connection': {
        const analyticsData = {
          event_name: EVENT_NAME.CONNECTION_DASHBOARD_ENTRY,
          product_type: 0,
          product_type_id: 0,
          screen_name: SCREEN_NAME.GRAND_ROUND,
          start_time: this.sessiontime.end_time,
          end_time:  this.sessiontime.end_time
        };
        this.analyticsEventService.logAnalyticsEvent(analyticsData, false, true);
        this.masterSer.url_after_leave_cme = 'connection/suggestion';
        this.fcs.navigateToConnection();
        break;
      }

      case 'survey': {
        this.masterSer.url_after_leave_cme = 'survey/list/all';
        this.fcs.navigateToSurvey();
        break;
      }
      case 'clinical': {
        this.masterSer.url_after_leave_cme = '/clinical';
        this.router.navigateByUrl('/clinical/list');
        break;
      }

      case 'webinar': {
        this.masterSer.url_after_leave_cme = '/webinar';
        this.router.navigateByUrl('/webinar/list/all');
        break;
      }

      case 'posting': {
        this.dss.show_feed_post_modal.next(1);
        break;
      }
      case 'gr': {
        this.fcs.navigateToFeedDetail(exp.product_id);
        break;
      }

      case 'tnc': {
        if (exp.target_url != '') {
          window.open(exp.target_url, '_blank');
          break;
        }
        break;
      }
      case 'otsuka_form': {

        this.analyticsData = {
          'event_name': EVENT_NAME.EXPLORE_OTSUKA_CLICK,
          'product_type': 0,
          'product_type_id': 0,
          'screen_name': SCREEN_NAME.GRAND_ROUND,
          'start_time': this.sessiontime.start_time,
          'end_time': this.sessiontime.start_time
        };
        
        this.analyticsEventService.logAnalyticsEvent(this.analyticsData);
          this.fcs.navigateToPatientList();
          break;
      }
      case 'vault': {
        this.fcs.navigateToVault();
        break;
      }

      case 'gr_filter': {
        const filter = JSON.parse(exp.target_url);
        this.dss.gr_filter = filter;
        this.router.navigateByUrl('/web/list');

        break;
      }

      case 'calender': {
        this.fcs.navigateToCalenderModule();
        break;
      }
      case NAVIGATION_TARGET.ONLINE_EVENT:
      case NAVIGATION_TARGET.PHARMA: {
        this.fcs.redirectOnSection(exp.value, '');
        break;
      }

      case 'community': {
        this.fcs.navigateToCommunityModule();
        break;
      }

      case 'editors_choice': {
        const filter = [{ key: 'properties', value: ['editors_choice'] }];
        this.dss.gr_filter = filter;
        this.router.navigateByUrl('/web/list');
        break;
      }

      case 'dx': {
        this.fcs.getDXToken();
        break;
      }

    }
  }
  /**
   * log analytics click event
   */
  logClickEvent(productType: string, actionOn: string, ctaType: string): void {
    this.analyticSdk.analyticService.CLICK(productType, 0, SCREEN_NAME.EXPLORE_LIST,ctaType, ACTION_TYPE.CLICK, actionOn, null);
  }


  /**
   * Unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    const exitData:EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.OTHER,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.EXPLORE_LIST,
      start_time: this.exploreEntryTimeStamp,
      end_time: new Date().getTime(),
    }
    this.analyticSdk.analyticService.EXIT(exitData);
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
